/*
 * File: c:\Users\t.boisseau\Desktop\AUTOBUY\AutobuyBackOffice\src\Content\LoadingScreen\LoadingLines\LoadingLines.tsx
 * Project: c:\Users\t.boisseau\Desktop\AUTOBUY\AutobuyBackOffice
 * Created Date: Thursday July 31st 2025
 * Author: Tommy Boisseau
 * -----
 * Last Modified: Thursday July 31st 2025 4:15:31 pm
 * Modified By: the developer formerly known as Tommy Boisseau at t.boisseau@autobuy.fr
 * -----
 * Copyright (c) 2025 Autobuy SAS
 * -----
 */

import Styles from "Content/LoadingScreen/LoadingLines/LoadingLines.module.css";
import LoadingScreen from "../LoadingScreen";
import DoneIcon from '@mui/icons-material/Done';

type LoadingLinesProps = {
    width?: string;
    height?: string;
    lines: { key: string; value: string; }[];
}

function LoadingLines(props: LoadingLinesProps ) {
    return (
        <div className={`${Styles.loadingContainer}`} style={{ width: `${props?.width ?? "50vh"}`, height: `${props?.height ?? "20vh"}`}}>
            {props.lines.map((line, index) => (
                <div className={`${Styles.loadingLine}`} key={index}>
                    {line.value.includes("100")
                        ? (<DoneIcon color="success" sx={{ height: '1rem', width: '1rem' }} />)
                        : (<LoadingScreen height="1rem" width="1rem" color="green" borderWidth="2px" />)
                    }
                    <p className={`${Styles.loadingText}`}>
                        {line.key}: <strong>{line.value}</strong>
                    </p>
                </div>
            ))}
        </div>
    );
};

export default LoadingLines;
